import { render, staticRenderFns } from "./aqgfManageSystem.vue?vue&type=template&id=5052faff&scoped=true&"
import script from "./aqgfManageSystem.vue?vue&type=script&lang=js&"
export * from "./aqgfManageSystem.vue?vue&type=script&lang=js&"
import style0 from "./aqgfManageSystem.vue?vue&type=style&index=0&id=5052faff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052faff",
  null
  
)

export default component.exports